import 'selectize';

import '../select-plugins/clear_selection';
import remoteSelectize from '../custom-selectize/selectize-remote';

export function selectselectize() {
  $('select.selectize').each(function () {
    if (!$(this)[0].selectize) {
      const $select = $(this);

      $select.selectize({
        selectOnTab: true,
        dropdownParent: 'body',
        plugins: {
          clear_selection: {},
        },

        onChange(value) {
          const el = $select[0];

          el.dispatchEvent(
            new CustomEvent('selectize:change', {
              bubbles: true,
              detail: { value },
            })
          );
        },
      });
    }
  });
  $('select.selectize-modal').each(function () {
    if (!$(this)[0].selectize) {
      const $select = $(this);

      $select.selectize({
        selectOnTab: true,
        plugins: {
          clear_selection: {},
        },

        onChange(value) {
          $select[0].dispatchEvent(
            new CustomEvent('selectize:change', {
              bubbles: true,
              detail: { value },
            })
          );
        },
      });
    }
  });
  $('select.selectize-multi-modal').each(function () {
    if (!$(this)[0].selectize) {
      $(this).selectize({
        maxItems: 20,
        selectOnTab: true,
        plugins: {
          clear_selection: {},
          remove_button: {},
        },
      });
    }
  });
  $('select.selectize-single-modal').each(function () {
    if (!$(this)[0].selectize) {
      $(this).selectize({
        maxItems: 1,
        selectOnTab: true,
        plugins: {
          clear_selection: {},
        },
      });
    }
  });
  $('select.selectize-multi-create').each(function () {
    if (!$(this)[0].selectize) {
      $(this).selectize({
        maxItems: 5,
        delimiter: ',',
        selectOnTab: true,
        create: function (input) {
          return {
            value: input,
            text: input,
          };
        },
        plugins: {
          clear_selection: {},
          remove_button: {},
        },
      });
    }
  });
  $('select.selectize-modules').each(function () {
    if (!$(this)[0].selectize) {
      $(this).selectize({
        maxItems: 30,
        selectOnTab: true,
        dropdownParent: 'body',
        plugins: {
          clear_selection: {},
          remove_button: {},
        },
      });
    }
  });

  $('select.selectize-multi-locked').each(function () {
    if (!$(this)[0].selectize) {
      const lockedItems = ($(this).data('locked') || []).map(String)

      $(this).selectize({
        maxItems: 20,
        selectOnTab: true,
        plugins: {
          clear_selection: {},
          remove_button: {},
        },
        onDelete(values) {
          const removingLocked = values.some(value =>
            lockedItems.includes(String(value))
          )
          return !removingLocked
        }
      });
    }
  });
  $('select.selectize-create').each(function () {
    if (!$(this)[0].selectize) {
      const $select = $(this);

      $select.selectize({
        selectOnTab: true,

        create(input) {
          return {
            value: input,
            text: input,
          };
        },

        render: {
          option_create(data, escape) {
            return `<div class="create">Adicionar <strong>${escape(data.input)}</strong></div>`;
          },
        },

        plugins: {
          clear_selection: {},
        },

        onChange(value) {
          $select[0].dispatchEvent(
            new CustomEvent('selectize:change', {
              bubbles: true,
              detail: { value },
            })
          );
        },
      });
    }
  });
}

$(() => {
  selectselectize();
  remoteSelectize();
});

// O conteudo da modal da ST e injetado depois do ready (edit.js.slim), entao os
// selects dela nao existiam quando o callback acima rodou. As funcoes sao
// idempotentes: quem ja tem `selectize` e ignorado.
// Namespace `.selectize` nos dois: este pack e importado por filters.js, que
// entra em todo pack de datatable, e tambem e reavaliado quando uma partial com
// `javascript_pack_tag` e injetada por ajax. Sem o `.off()` cada reexecucao
// somava mais um par de handlers.
$(document)
  .off('shown.bs.modal.selectize')
  .on('shown.bs.modal.selectize', () => {
    selectselectize();
    remoteSelectize();
  });
